if (!customElements.get("engraving-selector")) {
  customElements.define(
    "engraving-selector",
    class EngravingSelector extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          propertyName: this.dataset.propertyName,
          productFormWebComponent: "product-form",
          productFormSelector: "product-form form",
          productAddToCartSelector: "button.product-form__submit",
          variantPersonalised: this.dataset.variantPersonalised,
          variantPlayer: this.dataset.variantPlayer,
        };
        this.playerBlock = this.querySelector("#number-player");
        this.customBlock = this.querySelector("#custom-name");
        this.customNumber = this.customBlock.querySelector(
          'input[name="dorsal"]',
        );
        this.customName = this.customBlock.querySelector(
          'input[name="player"]',
        );
        this.selectPlayer = this.querySelector("select#player");

        this.addEventListeners();
      }

      connectedCallback() {
        setTimeout(() => {
          let propertyNameLower = this.selectors.propertyName.toLowerCase();
          let variantFieldset = document.querySelector(
            `fieldset.variant-type-${propertyNameLower}`,
          );
          if (variantFieldset) {
            const selectedInput =
              variantFieldset.querySelector("input:checked");
            this.toggleBlocks(
              selectedInput.value,
              !selectedInput.classList.contains("disabled"),
            );
            this.clearCustom();
            // Llamar al manejador de cambio de jugador
            this._handlePlayerChange();
          }
        }, 250);
      }

      addEventListeners() {
        this.selectPlayer.addEventListener(
          "change",
          this.changePlayer.bind(this),
        );
        this.customNumber.addEventListener(
          "keyup",
          this.onNumbersType.bind(this),
        );
        this.customNumber.addEventListener(
          "change",
          this.onChangeNumber.bind(this),
        );
        this.customName.addEventListener("keyup", this.onNameType.bind(this));
        this.customName.addEventListener(
          "change",
          this.onChangeName.bind(this),
        );
        // Mostrar el div cuando cambia el selectPlayer
        this.selectPlayer.addEventListener(
          "change",
          this._handlePlayerChange.bind(this),
        );
      }

      displayEngraving(event) {
        const fieldset = event.target.closest("fieldset");
        let propertyNameLower = this.selectors.propertyName.toLowerCase();
        if (fieldset.classList.contains(`variant-type-${propertyNameLower}`)) {
          const selectedInput = fieldset.querySelector("input:checked");
          this.toggleBlocks(
            selectedInput.value,
            !selectedInput.classList.contains("disabled"),
          );
          // Llamar al manejador de cambio de jugador
          this._handlePlayerChange(event);
        }
      }

      changePlayer(event) {
        this.changeProperty(event.target.value);
        this._handlePlayerChange(event);
      }

      onNumbersType(event) {
        event.target.value = event.target.value.replace(/[^0-9]/g, "");
        this.countCharacters(event);
        this._updatePreview();
      }

      onNameType(event) {
        this.countCharacters(event);
        this._updatePreview();
      }

      onChangeNumber(event) {
        this.changeProperty(`${event.target.value} - ${this.customName.value}`);
        this._updatePreview();
      }

      onChangeName(event) {
        this.changeProperty(
          `${this.customNumber.value} - ${event.target.value}`,
        );
        this._updatePreview();
      }

      changeProperty(propertyValue) {
        let [number, name] = propertyValue
          ? propertyValue.split(" - ")
          : ["", ""];
        number = number.trim() === "" ? "**" : number;
        name = name.trim() === "" ? "**" : name;

        const productForm = document.querySelector(
          this.selectors.productFormSelector,
        );
        const propertyField = productForm.querySelector(
          `input[name="properties[${this.selectors.propertyName}]"]`,
        );
        propertyField.value = `${number} | ${name}`;

        // Update all preview-selector elements (use empty when placeholder '**')
        try {
          const previewSelectors =
            document.querySelectorAll("preview-selector");
          previewSelectors.forEach((preview) => {
            preview.number =
              number.trim() === "" || number.trim() === "**"
                ? ""
                : number.trim();
            preview.name =
              name.trim() === "" || name.trim() === "**" ? "" : name.trim();
          });
        } catch (e) {
          // ignore if anything goes wrong
        }
      }

      clearCustom() {
        this.customNumber.value = "";
        this.customName.value = "";
        this._updatePreview();
      }

      _updatePreview() {
        try {
          // Actualizar todos los preview-selector en la página
          const previewSelectors =
            document.querySelectorAll("preview-selector");
          previewSelectors.forEach((preview) => {
            // set properties directly from inputs
            preview.number = this.customNumber ? this.customNumber.value : "";
            preview.name = this.customName ? this.customName.value : "";
          });
        } catch (e) {
          // no-op
        }
        // Mostrar el div cuando hay valores en los campos personalizados
        this._handleCustomFieldChange();
      }

      toggleBlocks(variantName, available = true) {
        this.removePropertyField();

        if (variantName === this.selectors.variantPlayer) {
          this.showPlayerBlock(available);
          this.goToPreviewImage();
          this._handlePlayerChange();
        } else if (variantName === this.selectors.variantPersonalised) {
          this.showCustomBlock(available);
          this.goToPreviewImage();
          this._handleCustomFieldChange();
        } else {
          this.hideBlocks();
        }
      }

      showPlayerBlock(available) {
        this.customBlock.setAttribute("hidden", false);
        this.playerBlock.removeAttribute("hidden");
        this.toggleAvailability(this.selectPlayer, available);
        this.clearCustom();
        this.createPropertyField();
        this.changeProperty(this.selectPlayer.value);
      }

      showCustomBlock(available) {
        this.playerBlock.setAttribute("hidden", false);
        this.customBlock.removeAttribute("hidden");
        this.toggleAvailability(this.customNumber, available);
        this.toggleAvailability(this.customName, available);
        this.createPropertyField();
      }

      hideBlocks() {
        this.customBlock.setAttribute("hidden", true);
        this.playerBlock.setAttribute("hidden", true);
        this.clearCustom();
      }

      toggleAvailability(element, available) {
        if (available) {
          element.removeAttribute("disabled");
        } else {
          element.setAttribute("disabled", true);
        }
      }

      createPropertyField() {
        const propertyField = document.createElement("input");
        propertyField.setAttribute("type", "hidden");
        propertyField.setAttribute(
          "name",
          `properties[${this.selectors.propertyName}]`,
        );
        document
          .querySelector(this.selectors.productFormSelector)
          .appendChild(propertyField);
      }

      removePropertyField() {
        const productForm = document.querySelector(
          this.selectors.productFormSelector,
        );
        const propertyField = productForm.querySelector(
          `input[name="properties[${this.selectors.propertyName}]"]`,
        );
        if (propertyField) {
          propertyField.remove();
        }
      }

      countCharacters(event) {
        const maxNumOfChars = event.target.getAttribute("maxlength");
        const counterElement = event.target
          .closest(".input")
          .querySelector(".character-counter span");
        counterElement.innerText = `${event.target.value.length}/${maxNumOfChars}`;
      }

      _setSecondImageVisibility() {
        const secondImage = document.getElementById("secondImageMobile");
        if (secondImage) {
          secondImage.style.display = "block";
        }
      }

      _handlePlayerChange(event) {
        const secondImage = document.getElementById("secondImageMobile");
        if (!secondImage) return;

        // Mostrar si el bloque de jugador está visible (sin requerir valor seleccionado)
        if (!this.playerBlock.hasAttribute("hidden")) {
          secondImage.style.display = "block";
          this._navigateToSecondImageOnMobile();
        } else {
          secondImage.style.display = "none";
        }
      }

      _handleCustomFieldChange() {
        const secondImage = document.getElementById("secondImageMobile");
        if (!secondImage) return;

        // Mostrar si el bloque personalizado está visible (sin requerir valores en los campos)
        if (!this.customBlock.hasAttribute("hidden")) {
          secondImage.style.display = "block";
          this._navigateToSecondImageOnMobile();
        } else if (this.customBlock.hasAttribute("hidden")) {
          // Si el bloque personalizado está oculto, no mostrar el div
          secondImage.style.display = "none";
        }
      }

      _navigateToSecondImageOnMobile() {
        if (!window.matchMedia("(max-width: 749px)").matches) return;

        setTimeout(() => {
          const slider = document.querySelector(
            ".product__media-list.slider--mobile",
          );
          if (!slider) return;

          const slides = slider.querySelectorAll("[data-media-id]");
          if (slides.length < 2) return;

          const slideWidth = slides[0].offsetWidth;
          slider.scrollLeft = slideWidth;
        }, 500);
      }
    },
  );
}
